import { Outlet, createFileRoute } from "@tanstack/react-router";

import VStack from "@/components/Layout/VStack";

import Header from "./-layout/Header";

export const Route = createFileRoute("/_staff/app-integrations/$id/_$id")({
  component: Layout,
});

export default function Layout() {
  return (
    <VStack>
      <Header />
      <Outlet />
    </VStack>
  );
}
